

// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { walletAccountStatuses } from '../statuses';

export default class WalletAccountsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'wallet-accounts';
        this.Server = this.props.context.getState().server.walletAccounts;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'accountNumber'];

        const defaultHead = [
            {
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'userId',
                label: 'user',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'walletUsers',
                object: 'user',
                show: 'email'
            },
            {
                id: 'accountNumber',
                label: 'accountNumber',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'status',
                label: 'status',
                alignRight: false,
                cell: 'Items',
                displayGrid: true,
                items: Object.values(walletAccountStatuses)
            },
            {
                id: 'currencyId',
                label: 'currency',
                alignRight: false,
                cell: 'Select',
                displayGrid: true,
                from: 'currencies',
                object: 'currency',
                show: 'name'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

